/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/billpayment/service.proto" (package "rd.api.billpayment", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Receivable } from "../../txn/models_pb";
import { TimestampRange } from "../../proto/timestamprange/models_pb";
import { User } from "../../user/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { TaxLine } from "../../txn/models_pb";
import { AllocatedReceivable } from "../../txn/models_pb";
import { LedgerMethods } from "../../ledger/models_pb";
import { Method_Type } from "../../company/tender/models_pb";
import { LedgerEntry } from "../../ledger/models_pb";
import { CreditHistoryLink } from "../../txn/models_pb";
import { Customer } from "../../customer/models_pb";
import { Card } from "../../payments/models_pb";
import { PurchaseOrder } from "../../customer/models_pb";
import { Sale } from "../../txn/models_pb";
import { BillPayment } from "../../txn/models_pb";
import { TenderSubmissionMetadata } from "../../txn/models_pb";
import { Decimal } from "../../proto/decimal/models_pb";
import { Money } from "../../proto/money/models_pb";
import { UUID } from "../../proto/uuid/models_pb";
/**
 * @generated from protobuf message rd.api.billpayment.CreateBillPaymentV3Req
 */
export interface CreateBillPaymentV3Req {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string notes = 5
     */
    notes: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge = 7
     */
    cardSurcharge?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal card_surcharge_rate = 8
     */
    cardSurchargeRate?: Decimal;
    /**
     * @generated from protobuf field: string idempotency_key = 11
     */
    idempotencyKey: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID printer_id = 12
     */
    printerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money credits_added = 14
     */
    creditsAdded?: Money; // positive
    /**
     * @generated from protobuf field: string credit_notes = 15
     */
    creditNotes: string;
    /**
     * positive for charge allocations, negative for credit allocations
     *
     * @generated from protobuf field: map<string, rd.proto.money.Money> allocations_by_ledger_entry_id = 17
     */
    allocationsByLedgerEntryId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata tender_submission = 18
     */
    tenderSubmission?: TenderSubmissionMetadata;
}
/**
 * @generated from protobuf message rd.api.billpayment.CreateBillPaymentV3Res
 */
export interface CreateBillPaymentV3Res {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.RefundBillPaymentReq
 */
export interface RefundBillPaymentReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: string notes = 3
     */
    notes: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID printer_id = 6
     */
    printerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID cash_register_id = 7
     */
    cashRegisterId?: UUID;
    /**
     * @generated from protobuf field: rd.txn.TenderSubmissionMetadata tender_submission_metadata = 9
     */
    tenderSubmissionMetadata?: TenderSubmissionMetadata;
}
/**
 * @generated from protobuf message rd.api.billpayment.RefundBillPaymentRes
 */
export interface RefundBillPaymentRes {
}
/**
 * @generated from protobuf message rd.api.billpayment.CreateWriteOffReq
 */
export interface CreateWriteOffReq {
}
/**
 * @generated from protobuf message rd.api.billpayment.CreateWriteOffRes
 */
export interface CreateWriteOffRes {
}
/**
 * @generated from protobuf message rd.api.billpayment.GetBillPaymentReq
 */
export interface GetBillPaymentReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetBillPaymentRes
 */
export interface GetBillPaymentRes {
    /**
     * @generated from protobuf field: rd.txn.BillPayment bill_payment = 1
     */
    billPayment?: BillPayment;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 4
     */
    amount?: Money;
    /**
     * @generated from protobuf field: map<string, rd.txn.Sale> sales_by_id = 6
     */
    salesById: {
        [key: string]: Sale;
    };
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> allocations_by_sale_id = 7
     */
    allocationsBySaleId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: map<string, rd.customer.PurchaseOrder> purchase_orders_by_id = 9
     */
    purchaseOrdersById: {
        [key: string]: PurchaseOrder;
    };
    /**
     * @generated from protobuf field: rd.payments.Card payment_card = 10
     */
    paymentCard?: Card;
    /**
     * @generated from protobuf field: rd.proto.money.Money card_surcharge = 11
     */
    cardSurcharge?: Money;
    /**
     * TODO: (CUSTOM_METHODS_OF_TENDER) Reserve
     *
     * @generated from protobuf field: string payment_method = 13
     */
    paymentMethod: string;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> discounts_by_sale_id = 14
     */
    discountsBySaleId: {
        [key: string]: Money;
    }; // negative amounts
    /**
     * @generated from protobuf field: rd.proto.money.Money discounts_total = 15
     */
    discountsTotal?: Money; // negative
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> reverse_discounts_by_sale_id = 16
     */
    reverseDiscountsBySaleId: {
        [key: string]: Money;
    }; // positive amounts
    /**
     * @generated from protobuf field: rd.proto.money.Money reverse_discounts_total = 17
     */
    reverseDiscountsTotal?: Money; // positive
    /**
     * @generated from protobuf field: map<string, rd.customer.Customer> customers_by_id = 18
     */
    customersById: {
        [key: string]: Customer;
    };
    /**
     * @generated from protobuf field: repeated rd.api.billpayment.GetBillPaymentRes.AllocatedFinanceCharge allocated_finance_charges = 21
     */
    allocatedFinanceCharges: GetBillPaymentRes_AllocatedFinanceCharge[];
    /**
     * @generated from protobuf field: rd.txn.CreditHistoryLink credit_history_data = 23
     */
    creditHistoryData?: CreditHistoryLink;
    /**
     * @generated from protobuf field: rd.ledger.LedgerEntry ledger_entry = 25
     */
    ledgerEntry?: LedgerEntry;
    /**
     * TODO: (CUSTOM_METHODS_OF_TENDER) Reserve
     *
     * @generated from protobuf field: rd.company.tender.Method.Type tender_method_type = 26
     */
    tenderMethodType: Method_Type;
    /**
     * @generated from protobuf field: rd.ledger.LedgerMethods ledger_methods = 27
     */
    ledgerMethods?: LedgerMethods;
    /**
     * @generated from protobuf field: repeated rd.txn.AllocatedReceivable allocated_receivables = 28
     */
    allocatedReceivables: AllocatedReceivable[];
    /**
     * @generated from protobuf field: rd.proto.money.Money allocated_credits = 29
     */
    allocatedCredits?: Money; // amount of credits allocated to the bill payment
    /**
     * @generated from protobuf field: bool is_ach_refund_eligible = 30
     */
    isAchRefundEligible: boolean;
    /**
     * surcharge_taxes lists the bill payment's card-fee tax rates with the rate
     * name joined from the TaxRate table, ordered for stable display.
     *
     * @generated from protobuf field: repeated rd.txn.TaxLine surcharge_taxes = 31
     */
    surchargeTaxes: TaxLine[];
}
/**
 * @generated from protobuf message rd.api.billpayment.GetBillPaymentRes.AllocatedFinanceCharge
 */
export interface GetBillPaymentRes_AllocatedFinanceCharge {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money allocated_amount = 3
     */
    allocatedAmount?: Money;
    /**
     * @generated from protobuf field: string location_prefix = 4
     */
    locationPrefix: string;
    /**
     * @generated from protobuf field: string location_name = 5
     */
    locationName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp assessed_at = 6
     */
    assessedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 7
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 8
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string customer_identifier = 9
     */
    customerIdentifier: string;
    /**
     * @generated from protobuf field: string customer_name = 10
     */
    customerName: string;
    /**
     * @generated from protobuf field: bool is_job_finance_charge = 11
     */
    isJobFinanceCharge: boolean;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetScannedBillPaymentReq
 */
export interface GetScannedBillPaymentReq {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetScannedBillPaymentRes
 */
export interface GetScannedBillPaymentRes {
    /**
     * @generated from protobuf field: rd.txn.BillPayment bill_payment = 1
     */
    billPayment?: BillPayment;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetBillPaymentPDFReq
 */
export interface GetBillPaymentPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetBillPaymentPDFRes
 */
export interface GetBillPaymentPDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.billpayment.EmailBillPaymentPDFReq
 */
export interface EmailBillPaymentPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: repeated string customer_contact_id_strings = 2
     */
    customerContactIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string additional_emails = 3
     */
    additionalEmails: string[];
}
/**
 * @generated from protobuf message rd.api.billpayment.EmailBillPaymentPDFRes
 */
export interface EmailBillPaymentPDFRes {
}
/**
 * @generated from protobuf message rd.api.billpayment.CalculateBillPaymentCardSurchargeReq
 */
export interface CalculateBillPaymentCardSurchargeReq {
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 1
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 2
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: bool is_card_payment = 3
     */
    isCardPayment: boolean;
    /**
     * @generated from protobuf field: bool is_card_surcharge_disabled = 5
     */
    isCardSurchargeDisabled: boolean;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 6
     */
    locationId?: UUID; // drives multi-rate tax selection
}
/**
 * @generated from protobuf message rd.api.billpayment.CalculateBillPaymentCardSurchargeRes
 */
export interface CalculateBillPaymentCardSurchargeRes {
    /**
     * @generated from protobuf field: rd.proto.money.Money surcharge = 1
     */
    surcharge?: Money;
    /**
     * surcharge_taxes is the per-rate card-fee tax breakdown with rate names joined
     * from the TaxRate table. Empty when the surcharge is untaxed (e.g. tax-exempt).
     *
     * @generated from protobuf field: repeated rd.txn.TaxLine surcharge_taxes = 3
     */
    surchargeTaxes: TaxLine[];
}
/**
 * @generated from protobuf message rd.api.billpayment.GetIsVoidingBillPaymentAllowedReq
 */
export interface GetIsVoidingBillPaymentAllowedReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetIsVoidingBillPaymentAllowedRes
 */
export interface GetIsVoidingBillPaymentAllowedRes {
    /**
     * @generated from protobuf field: bool is_allowed = 1
     */
    isAllowed: boolean;
    /**
     * @generated from protobuf field: repeated string blocked_reasons = 2
     */
    blockedReasons: string[];
}
/**
 * @generated from protobuf message rd.api.billpayment.VoidBillPaymentReq
 */
export interface VoidBillPaymentReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string void_notes = 2
     */
    voidNotes: string;
}
/**
 * @generated from protobuf message rd.api.billpayment.VoidBillPaymentRes
 */
export interface VoidBillPaymentRes {
}
/**
 * @generated from protobuf message rd.api.billpayment.GetIsEditingBillPaymentDateAllowedReq
 */
export interface GetIsEditingBillPaymentDateAllowedReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetIsEditingBillPaymentDateAllowedRes
 */
export interface GetIsEditingBillPaymentDateAllowedRes {
    /**
     * @generated from protobuf field: bool is_allowed = 1
     */
    isAllowed: boolean;
    /**
     * @generated from protobuf field: repeated string blocked_reasons = 2
     */
    blockedReasons: string[];
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange allowed_date_range = 3
     */
    allowedDateRange?: TimestampRange;
}
/**
 * @generated from protobuf message rd.api.billpayment.UpdateBillPaymentDateReq
 */
export interface UpdateBillPaymentDateReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 2
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: string client_time_zone = 3
     */
    clientTimeZone: string;
}
/**
 * @generated from protobuf message rd.api.billpayment.UpdateBillPaymentDateRes
 */
export interface UpdateBillPaymentDateRes {
}
/**
 * @generated from protobuf message rd.api.billpayment.GetIsReallocatingBillPaymentAllowedReq
 */
export interface GetIsReallocatingBillPaymentAllowedReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID bill_id = 1
     */
    billId?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetIsReallocatingBillPaymentAllowedRes
 */
export interface GetIsReallocatingBillPaymentAllowedRes {
    /**
     * @generated from protobuf field: bool is_allowed = 1
     */
    isAllowed: boolean;
    /**
     * @generated from protobuf field: repeated string blocked_reasons = 2
     */
    blockedReasons: string[];
}
/**
 * @generated from protobuf message rd.api.billpayment.ReallocateBillPaymentReq
 */
export interface ReallocateBillPaymentReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID bill_id = 1
     */
    billId?: UUID;
    /**
     * @generated from protobuf field: map<string, rd.api.billpayment.ReallocateBillPaymentReq.Allocation> reallocations_by_id = 2
     */
    reallocationsById: {
        [key: string]: ReallocateBillPaymentReq_Allocation;
    };
    /**
     * @generated from protobuf field: rd.proto.money.Money unallocated_credits_added = 3
     */
    unallocatedCreditsAdded?: Money;
    /**
     * @generated from protobuf field: string notes = 4
     */
    notes: string;
    /**
     * @generated from protobuf field: string credit_notes = 5
     */
    creditNotes: string;
}
/**
 * @generated from protobuf message rd.api.billpayment.ReallocateBillPaymentReq.Allocation
 */
export interface ReallocateBillPaymentReq_Allocation {
    /**
     * sale id for purchases, ledger entry id for finance charges and credits
     *
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 2
     */
    amount?: Money;
    /**
     * @generated from protobuf field: rd.api.billpayment.ReallocateBillPaymentReq.Type type = 3
     */
    type: ReallocateBillPaymentReq_Type;
}
/**
 * @generated from protobuf enum rd.api.billpayment.ReallocateBillPaymentReq.Type
 */
export enum ReallocateBillPaymentReq_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * positive amount
     *
     * @generated from protobuf enum value: TYPE_PURCHASE = 1;
     */
    PURCHASE = 1,
    /**
     * positive amount
     *
     * @generated from protobuf enum value: TYPE_FINANCE_CHARGE = 2;
     */
    FINANCE_CHARGE = 2,
    /**
     * negative amount
     *
     * @generated from protobuf enum value: TYPE_CREDIT = 3;
     */
    CREDIT = 3
}
/**
 * @generated from protobuf message rd.api.billpayment.ReallocateBillPaymentRes
 */
export interface ReallocateBillPaymentRes {
}
/**
 * @generated from protobuf message rd.api.billpayment.GetFinanceChargeReq
 */
export interface GetFinanceChargeReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetFinanceChargeRes
 */
export interface GetFinanceChargeRes {
    /**
     * @generated from protobuf field: string identifier = 1
     */
    identifier: string;
    /**
     * @generated from protobuf field: string location_prefix = 2
     */
    locationPrefix: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 3
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp assessed_at = 4
     */
    assessedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money adjustment = 5
     */
    adjustment?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal rate = 6
     */
    rate?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 7
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money net_allocated_amount = 8
     */
    netAllocatedAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total_balance = 9
     */
    totalBalance?: Money;
    /**
     * @generated from protobuf field: repeated rd.api.billpayment.GetFinanceChargeRes.AssessedTransaction assessed_transactions = 10
     */
    assessedTransactions: GetFinanceChargeRes_AssessedTransaction[];
}
/**
 * @generated from protobuf message rd.api.billpayment.GetFinanceChargeRes.AssessedTransaction
 */
export interface GetFinanceChargeRes_AssessedTransaction {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_at = 4
     */
    dueAt?: Timestamp;
    /**
     * @generated from protobuf field: string transaction_type = 5
     */
    transactionType: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID job_id = 6
     */
    jobId?: UUID;
    /**
     * @generated from protobuf field: string job_identifier = 7
     */
    jobIdentifier: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money balance = 8
     */
    balance?: Money;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetFinanceChargePDFReq
 */
export interface GetFinanceChargePDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetFinanceChargePDFRes
 */
export interface GetFinanceChargePDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.billpayment.EmailFinanceChargePDFReq
 */
export interface EmailFinanceChargePDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: repeated string customer_contact_id_strings = 2
     */
    customerContactIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string additional_emails = 3
     */
    additionalEmails: string[];
}
/**
 * @generated from protobuf message rd.api.billpayment.EmailFinanceChargePDFRes
 */
export interface EmailFinanceChargePDFRes {
}
/**
 * @generated from protobuf message rd.api.billpayment.GetIsVoidingFinanceChargeAllowedReq
 */
export interface GetIsVoidingFinanceChargeAllowedReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetIsVoidingFinanceChargeAllowedRes
 */
export interface GetIsVoidingFinanceChargeAllowedRes {
    /**
     * @generated from protobuf field: bool is_allowed = 1
     */
    isAllowed: boolean;
    /**
     * @generated from protobuf field: repeated string blocked_reasons = 2
     */
    blockedReasons: string[];
}
/**
 * @generated from protobuf message rd.api.billpayment.VoidFinanceChargeReq
 */
export interface VoidFinanceChargeReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.VoidFinanceChargeRes
 */
export interface VoidFinanceChargeRes {
}
/**
 * @generated from protobuf message rd.api.billpayment.GetCreditHistoryReq
 */
export interface GetCreditHistoryReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // ledger entry id
}
/**
 * @generated from protobuf message rd.api.billpayment.GetCreditHistoryRes
 */
export interface GetCreditHistoryRes {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID txn_id = 1
     */
    txnId?: UUID;
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string;
    /**
     * @generated from protobuf field: string location_prefix = 3
     */
    locationPrefix: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 4
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money allocated_total = 6
     */
    allocatedTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 7
     */
    total?: Money;
    /**
     * @generated from protobuf field: string notes = 8
     */
    notes: string;
    /**
     * @generated from protobuf field: string txn_identifier = 10
     */
    txnIdentifier: string;
    /**
     * @generated from protobuf field: rd.user.User created_by = 11
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.api.billpayment.GetCreditHistoryRes.Type type = 12
     */
    type: GetCreditHistoryRes_Type;
    /**
     * The core receivable that the history is associated with
     *
     * @generated from protobuf field: rd.txn.Receivable receivable = 13
     */
    receivable?: Receivable;
    /**
     * @generated from protobuf field: repeated rd.api.billpayment.GetCreditHistoryRes.ReceivableHistoryItem receivable_history = 14
     */
    receivableHistory: GetCreditHistoryRes_ReceivableHistoryItem[];
}
/**
 * @generated from protobuf message rd.api.billpayment.GetCreditHistoryRes.Allocation
 */
export interface GetCreditHistoryRes_Allocation {
}
/**
 * @generated from protobuf message rd.api.billpayment.GetCreditHistoryRes.ReceivableHistoryItem
 */
export interface GetCreditHistoryRes_ReceivableHistoryItem {
    /**
     *  The receivable that affected the core receivable's balance
     *
     * @generated from protobuf field: rd.txn.Receivable receivable = 1
     */
    receivable?: Receivable;
    /**
     * The change in the core receivable's balance
     * Positive for debits, negative for credits
     *
     * @generated from protobuf field: rd.proto.money.Money balance_delta = 2
     */
    balanceDelta?: Money;
    /**
     * The core receivable's running balance
     *
     * @generated from protobuf field: rd.proto.money.Money running_balance = 3
     */
    runningBalance?: Money;
}
/**
 * @generated from protobuf enum rd.api.billpayment.GetCreditHistoryRes.Type
 */
export enum GetCreditHistoryRes_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_BILL_PAYMENT = 1;
     */
    BILL_PAYMENT = 1,
    /**
     * @generated from protobuf enum value: TYPE_WRITE_OFF = 2;
     */
    WRITE_OFF = 2,
    /**
     * @generated from protobuf enum value: TYPE_RETURN = 3;
     */
    RETURN = 3,
    /**
     * @generated from protobuf enum value: TYPE_REFUND = 4;
     */
    REFUND = 4
}
/**
 * @generated from protobuf message rd.api.billpayment.GetCreditHistoryPDFReq
 */
export interface GetCreditHistoryPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetCreditHistoryPDFRes
 */
export interface GetCreditHistoryPDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.billpayment.EmailCreditHistoryPDFReq
 */
export interface EmailCreditHistoryPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: repeated string customer_contact_id_strings = 2
     */
    customerContactIdStrings: string[];
    /**
     * @generated from protobuf field: repeated string additional_emails = 3
     */
    additionalEmails: string[];
}
/**
 * @generated from protobuf message rd.api.billpayment.EmailCreditHistoryPDFRes
 */
export interface EmailCreditHistoryPDFRes {
}
/**
 * @generated from protobuf message rd.api.billpayment.GetNonFullyAllocatedCreditHistoryCountReq
 */
export interface GetNonFullyAllocatedCreditHistoryCountReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 1
     */
    customerId?: UUID;
}
/**
 * @generated from protobuf message rd.api.billpayment.GetNonFullyAllocatedCreditHistoryCountRes
 */
export interface GetNonFullyAllocatedCreditHistoryCountRes {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateBillPaymentV3Req$Type extends MessageType<CreateBillPaymentV3Req> {
    constructor() {
        super("rd.api.billpayment.CreateBillPaymentV3Req", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 5, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "card_surcharge", kind: "message", T: () => Money },
            { no: 8, name: "card_surcharge_rate", kind: "message", T: () => Decimal },
            { no: 11, name: "idempotency_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "printer_id", kind: "message", T: () => UUID },
            { no: 14, name: "credits_added", kind: "message", T: () => Money },
            { no: 15, name: "credit_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "allocations_by_ledger_entry_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 18, name: "tender_submission", kind: "message", T: () => TenderSubmissionMetadata }
        ]);
    }
    create(value?: PartialMessage<CreateBillPaymentV3Req>): CreateBillPaymentV3Req {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notes = "";
        message.idempotencyKey = "";
        message.creditNotes = "";
        message.allocationsByLedgerEntryId = {};
        if (value !== undefined)
            reflectionMergePartial<CreateBillPaymentV3Req>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateBillPaymentV3Req): CreateBillPaymentV3Req {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string notes */ 5:
                    message.notes = reader.string();
                    break;
                case /* rd.proto.money.Money card_surcharge */ 7:
                    message.cardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurcharge);
                    break;
                case /* rd.proto.decimal.Decimal card_surcharge_rate */ 8:
                    message.cardSurchargeRate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.cardSurchargeRate);
                    break;
                case /* string idempotency_key */ 11:
                    message.idempotencyKey = reader.string();
                    break;
                case /* rd.proto.uuid.UUID printer_id */ 12:
                    message.printerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.printerId);
                    break;
                case /* rd.proto.money.Money credits_added */ 14:
                    message.creditsAdded = Money.internalBinaryRead(reader, reader.uint32(), options, message.creditsAdded);
                    break;
                case /* string credit_notes */ 15:
                    message.creditNotes = reader.string();
                    break;
                case /* map<string, rd.proto.money.Money> allocations_by_ledger_entry_id */ 17:
                    this.binaryReadMap17(message.allocationsByLedgerEntryId, reader, options);
                    break;
                case /* rd.txn.TenderSubmissionMetadata tender_submission */ 18:
                    message.tenderSubmission = TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options, message.tenderSubmission);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap17(map: CreateBillPaymentV3Req["allocationsByLedgerEntryId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CreateBillPaymentV3Req["allocationsByLedgerEntryId"] | undefined, val: CreateBillPaymentV3Req["allocationsByLedgerEntryId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.billpayment.CreateBillPaymentV3Req.allocations_by_ledger_entry_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: CreateBillPaymentV3Req, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 5; */
        if (message.notes !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.notes);
        /* rd.proto.money.Money card_surcharge = 7; */
        if (message.cardSurcharge)
            Money.internalBinaryWrite(message.cardSurcharge, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal card_surcharge_rate = 8; */
        if (message.cardSurchargeRate)
            Decimal.internalBinaryWrite(message.cardSurchargeRate, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string idempotency_key = 11; */
        if (message.idempotencyKey !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.idempotencyKey);
        /* rd.proto.uuid.UUID printer_id = 12; */
        if (message.printerId)
            UUID.internalBinaryWrite(message.printerId, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money credits_added = 14; */
        if (message.creditsAdded)
            Money.internalBinaryWrite(message.creditsAdded, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* string credit_notes = 15; */
        if (message.creditNotes !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.creditNotes);
        /* map<string, rd.proto.money.Money> allocations_by_ledger_entry_id = 17; */
        for (let k of globalThis.Object.keys(message.allocationsByLedgerEntryId)) {
            writer.tag(17, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.allocationsByLedgerEntryId[k], writer, options);
            writer.join().join();
        }
        /* rd.txn.TenderSubmissionMetadata tender_submission = 18; */
        if (message.tenderSubmission)
            TenderSubmissionMetadata.internalBinaryWrite(message.tenderSubmission, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.CreateBillPaymentV3Req
 */
export const CreateBillPaymentV3Req = new CreateBillPaymentV3Req$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBillPaymentV3Res$Type extends MessageType<CreateBillPaymentV3Res> {
    constructor() {
        super("rd.api.billpayment.CreateBillPaymentV3Res", [
            { no: 1, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CreateBillPaymentV3Res>): CreateBillPaymentV3Res {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateBillPaymentV3Res>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateBillPaymentV3Res): CreateBillPaymentV3Res {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateBillPaymentV3Res, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.CreateBillPaymentV3Res
 */
export const CreateBillPaymentV3Res = new CreateBillPaymentV3Res$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefundBillPaymentReq$Type extends MessageType<RefundBillPaymentReq> {
    constructor() {
        super("rd.api.billpayment.RefundBillPaymentReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 3, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 6, name: "printer_id", kind: "message", T: () => UUID },
            { no: 7, name: "cash_register_id", kind: "message", T: () => UUID },
            { no: 9, name: "tender_submission_metadata", kind: "message", T: () => TenderSubmissionMetadata }
        ]);
    }
    create(value?: PartialMessage<RefundBillPaymentReq>): RefundBillPaymentReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.notes = "";
        if (value !== undefined)
            reflectionMergePartial<RefundBillPaymentReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefundBillPaymentReq): RefundBillPaymentReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* string notes */ 3:
                    message.notes = reader.string();
                    break;
                case /* rd.proto.uuid.UUID printer_id */ 6:
                    message.printerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.printerId);
                    break;
                case /* rd.proto.uuid.UUID cash_register_id */ 7:
                    message.cashRegisterId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.cashRegisterId);
                    break;
                case /* rd.txn.TenderSubmissionMetadata tender_submission_metadata */ 9:
                    message.tenderSubmissionMetadata = TenderSubmissionMetadata.internalBinaryRead(reader, reader.uint32(), options, message.tenderSubmissionMetadata);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefundBillPaymentReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 3; */
        if (message.notes !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.notes);
        /* rd.proto.uuid.UUID printer_id = 6; */
        if (message.printerId)
            UUID.internalBinaryWrite(message.printerId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID cash_register_id = 7; */
        if (message.cashRegisterId)
            UUID.internalBinaryWrite(message.cashRegisterId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.TenderSubmissionMetadata tender_submission_metadata = 9; */
        if (message.tenderSubmissionMetadata)
            TenderSubmissionMetadata.internalBinaryWrite(message.tenderSubmissionMetadata, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.RefundBillPaymentReq
 */
export const RefundBillPaymentReq = new RefundBillPaymentReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefundBillPaymentRes$Type extends MessageType<RefundBillPaymentRes> {
    constructor() {
        super("rd.api.billpayment.RefundBillPaymentRes", []);
    }
    create(value?: PartialMessage<RefundBillPaymentRes>): RefundBillPaymentRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RefundBillPaymentRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefundBillPaymentRes): RefundBillPaymentRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefundBillPaymentRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.RefundBillPaymentRes
 */
export const RefundBillPaymentRes = new RefundBillPaymentRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateWriteOffReq$Type extends MessageType<CreateWriteOffReq> {
    constructor() {
        super("rd.api.billpayment.CreateWriteOffReq", []);
    }
    create(value?: PartialMessage<CreateWriteOffReq>): CreateWriteOffReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateWriteOffReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateWriteOffReq): CreateWriteOffReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateWriteOffReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.CreateWriteOffReq
 */
export const CreateWriteOffReq = new CreateWriteOffReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateWriteOffRes$Type extends MessageType<CreateWriteOffRes> {
    constructor() {
        super("rd.api.billpayment.CreateWriteOffRes", []);
    }
    create(value?: PartialMessage<CreateWriteOffRes>): CreateWriteOffRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateWriteOffRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateWriteOffRes): CreateWriteOffRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateWriteOffRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.CreateWriteOffRes
 */
export const CreateWriteOffRes = new CreateWriteOffRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillPaymentReq$Type extends MessageType<GetBillPaymentReq> {
    constructor() {
        super("rd.api.billpayment.GetBillPaymentReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetBillPaymentReq>): GetBillPaymentReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetBillPaymentReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBillPaymentReq): GetBillPaymentReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBillPaymentReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetBillPaymentReq
 */
export const GetBillPaymentReq = new GetBillPaymentReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillPaymentRes$Type extends MessageType<GetBillPaymentRes> {
    constructor() {
        super("rd.api.billpayment.GetBillPaymentRes", [
            { no: 1, name: "bill_payment", kind: "message", T: () => BillPayment },
            { no: 4, name: "amount", kind: "message", T: () => Money },
            { no: 6, name: "sales_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Sale } },
            { no: 7, name: "allocations_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 9, name: "purchase_orders_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => PurchaseOrder } },
            { no: 10, name: "payment_card", kind: "message", T: () => Card },
            { no: 11, name: "card_surcharge", kind: "message", T: () => Money },
            { no: 13, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "discounts_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 15, name: "discounts_total", kind: "message", T: () => Money },
            { no: 16, name: "reverse_discounts_by_sale_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 17, name: "reverse_discounts_total", kind: "message", T: () => Money },
            { no: 18, name: "customers_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Customer } },
            { no: 21, name: "allocated_finance_charges", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetBillPaymentRes_AllocatedFinanceCharge },
            { no: 23, name: "credit_history_data", kind: "message", T: () => CreditHistoryLink },
            { no: 25, name: "ledger_entry", kind: "message", T: () => LedgerEntry },
            { no: 26, name: "tender_method_type", kind: "enum", T: () => ["rd.company.tender.Method.Type", Method_Type, "TYPE_"] },
            { no: 27, name: "ledger_methods", kind: "message", T: () => LedgerMethods },
            { no: 28, name: "allocated_receivables", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AllocatedReceivable },
            { no: 29, name: "allocated_credits", kind: "message", T: () => Money },
            { no: 30, name: "is_ach_refund_eligible", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "surcharge_taxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxLine }
        ]);
    }
    create(value?: PartialMessage<GetBillPaymentRes>): GetBillPaymentRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.salesById = {};
        message.allocationsBySaleId = {};
        message.purchaseOrdersById = {};
        message.paymentMethod = "";
        message.discountsBySaleId = {};
        message.reverseDiscountsBySaleId = {};
        message.customersById = {};
        message.allocatedFinanceCharges = [];
        message.tenderMethodType = 0;
        message.allocatedReceivables = [];
        message.isAchRefundEligible = false;
        message.surchargeTaxes = [];
        if (value !== undefined)
            reflectionMergePartial<GetBillPaymentRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBillPaymentRes): GetBillPaymentRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.BillPayment bill_payment */ 1:
                    message.billPayment = BillPayment.internalBinaryRead(reader, reader.uint32(), options, message.billPayment);
                    break;
                case /* rd.proto.money.Money amount */ 4:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* map<string, rd.txn.Sale> sales_by_id */ 6:
                    this.binaryReadMap6(message.salesById, reader, options);
                    break;
                case /* map<string, rd.proto.money.Money> allocations_by_sale_id */ 7:
                    this.binaryReadMap7(message.allocationsBySaleId, reader, options);
                    break;
                case /* map<string, rd.customer.PurchaseOrder> purchase_orders_by_id */ 9:
                    this.binaryReadMap9(message.purchaseOrdersById, reader, options);
                    break;
                case /* rd.payments.Card payment_card */ 10:
                    message.paymentCard = Card.internalBinaryRead(reader, reader.uint32(), options, message.paymentCard);
                    break;
                case /* rd.proto.money.Money card_surcharge */ 11:
                    message.cardSurcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.cardSurcharge);
                    break;
                case /* string payment_method */ 13:
                    message.paymentMethod = reader.string();
                    break;
                case /* map<string, rd.proto.money.Money> discounts_by_sale_id */ 14:
                    this.binaryReadMap14(message.discountsBySaleId, reader, options);
                    break;
                case /* rd.proto.money.Money discounts_total */ 15:
                    message.discountsTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.discountsTotal);
                    break;
                case /* map<string, rd.proto.money.Money> reverse_discounts_by_sale_id */ 16:
                    this.binaryReadMap16(message.reverseDiscountsBySaleId, reader, options);
                    break;
                case /* rd.proto.money.Money reverse_discounts_total */ 17:
                    message.reverseDiscountsTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.reverseDiscountsTotal);
                    break;
                case /* map<string, rd.customer.Customer> customers_by_id */ 18:
                    this.binaryReadMap18(message.customersById, reader, options);
                    break;
                case /* repeated rd.api.billpayment.GetBillPaymentRes.AllocatedFinanceCharge allocated_finance_charges */ 21:
                    message.allocatedFinanceCharges.push(GetBillPaymentRes_AllocatedFinanceCharge.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.txn.CreditHistoryLink credit_history_data */ 23:
                    message.creditHistoryData = CreditHistoryLink.internalBinaryRead(reader, reader.uint32(), options, message.creditHistoryData);
                    break;
                case /* rd.ledger.LedgerEntry ledger_entry */ 25:
                    message.ledgerEntry = LedgerEntry.internalBinaryRead(reader, reader.uint32(), options, message.ledgerEntry);
                    break;
                case /* rd.company.tender.Method.Type tender_method_type */ 26:
                    message.tenderMethodType = reader.int32();
                    break;
                case /* rd.ledger.LedgerMethods ledger_methods */ 27:
                    message.ledgerMethods = LedgerMethods.internalBinaryRead(reader, reader.uint32(), options, message.ledgerMethods);
                    break;
                case /* repeated rd.txn.AllocatedReceivable allocated_receivables */ 28:
                    message.allocatedReceivables.push(AllocatedReceivable.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money allocated_credits */ 29:
                    message.allocatedCredits = Money.internalBinaryRead(reader, reader.uint32(), options, message.allocatedCredits);
                    break;
                case /* bool is_ach_refund_eligible */ 30:
                    message.isAchRefundEligible = reader.bool();
                    break;
                case /* repeated rd.txn.TaxLine surcharge_taxes */ 31:
                    message.surchargeTaxes.push(TaxLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: GetBillPaymentRes["salesById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetBillPaymentRes["salesById"] | undefined, val: GetBillPaymentRes["salesById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Sale.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.billpayment.GetBillPaymentRes.sales_by_id");
            }
        }
        map[key ?? ""] = val ?? Sale.create();
    }
    private binaryReadMap7(map: GetBillPaymentRes["allocationsBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetBillPaymentRes["allocationsBySaleId"] | undefined, val: GetBillPaymentRes["allocationsBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.billpayment.GetBillPaymentRes.allocations_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap9(map: GetBillPaymentRes["purchaseOrdersById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetBillPaymentRes["purchaseOrdersById"] | undefined, val: GetBillPaymentRes["purchaseOrdersById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = PurchaseOrder.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.billpayment.GetBillPaymentRes.purchase_orders_by_id");
            }
        }
        map[key ?? ""] = val ?? PurchaseOrder.create();
    }
    private binaryReadMap14(map: GetBillPaymentRes["discountsBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetBillPaymentRes["discountsBySaleId"] | undefined, val: GetBillPaymentRes["discountsBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.billpayment.GetBillPaymentRes.discounts_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap16(map: GetBillPaymentRes["reverseDiscountsBySaleId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetBillPaymentRes["reverseDiscountsBySaleId"] | undefined, val: GetBillPaymentRes["reverseDiscountsBySaleId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.billpayment.GetBillPaymentRes.reverse_discounts_by_sale_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    private binaryReadMap18(map: GetBillPaymentRes["customersById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof GetBillPaymentRes["customersById"] | undefined, val: GetBillPaymentRes["customersById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Customer.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.billpayment.GetBillPaymentRes.customers_by_id");
            }
        }
        map[key ?? ""] = val ?? Customer.create();
    }
    internalBinaryWrite(message: GetBillPaymentRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.BillPayment bill_payment = 1; */
        if (message.billPayment)
            BillPayment.internalBinaryWrite(message.billPayment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money amount = 4; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.txn.Sale> sales_by_id = 6; */
        for (let k of globalThis.Object.keys(message.salesById)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Sale.internalBinaryWrite(message.salesById[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.proto.money.Money> allocations_by_sale_id = 7; */
        for (let k of globalThis.Object.keys(message.allocationsBySaleId)) {
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.allocationsBySaleId[k], writer, options);
            writer.join().join();
        }
        /* map<string, rd.customer.PurchaseOrder> purchase_orders_by_id = 9; */
        for (let k of globalThis.Object.keys(message.purchaseOrdersById)) {
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            PurchaseOrder.internalBinaryWrite(message.purchaseOrdersById[k], writer, options);
            writer.join().join();
        }
        /* rd.payments.Card payment_card = 10; */
        if (message.paymentCard)
            Card.internalBinaryWrite(message.paymentCard, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money card_surcharge = 11; */
        if (message.cardSurcharge)
            Money.internalBinaryWrite(message.cardSurcharge, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string payment_method = 13; */
        if (message.paymentMethod !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.paymentMethod);
        /* map<string, rd.proto.money.Money> discounts_by_sale_id = 14; */
        for (let k of globalThis.Object.keys(message.discountsBySaleId)) {
            writer.tag(14, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.discountsBySaleId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money discounts_total = 15; */
        if (message.discountsTotal)
            Money.internalBinaryWrite(message.discountsTotal, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.proto.money.Money> reverse_discounts_by_sale_id = 16; */
        for (let k of globalThis.Object.keys(message.reverseDiscountsBySaleId)) {
            writer.tag(16, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.reverseDiscountsBySaleId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money reverse_discounts_total = 17; */
        if (message.reverseDiscountsTotal)
            Money.internalBinaryWrite(message.reverseDiscountsTotal, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.customer.Customer> customers_by_id = 18; */
        for (let k of globalThis.Object.keys(message.customersById)) {
            writer.tag(18, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Customer.internalBinaryWrite(message.customersById[k], writer, options);
            writer.join().join();
        }
        /* repeated rd.api.billpayment.GetBillPaymentRes.AllocatedFinanceCharge allocated_finance_charges = 21; */
        for (let i = 0; i < message.allocatedFinanceCharges.length; i++)
            GetBillPaymentRes_AllocatedFinanceCharge.internalBinaryWrite(message.allocatedFinanceCharges[i], writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* rd.txn.CreditHistoryLink credit_history_data = 23; */
        if (message.creditHistoryData)
            CreditHistoryLink.internalBinaryWrite(message.creditHistoryData, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* rd.ledger.LedgerEntry ledger_entry = 25; */
        if (message.ledgerEntry)
            LedgerEntry.internalBinaryWrite(message.ledgerEntry, writer.tag(25, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.tender.Method.Type tender_method_type = 26; */
        if (message.tenderMethodType !== 0)
            writer.tag(26, WireType.Varint).int32(message.tenderMethodType);
        /* rd.ledger.LedgerMethods ledger_methods = 27; */
        if (message.ledgerMethods)
            LedgerMethods.internalBinaryWrite(message.ledgerMethods, writer.tag(27, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.AllocatedReceivable allocated_receivables = 28; */
        for (let i = 0; i < message.allocatedReceivables.length; i++)
            AllocatedReceivable.internalBinaryWrite(message.allocatedReceivables[i], writer.tag(28, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money allocated_credits = 29; */
        if (message.allocatedCredits)
            Money.internalBinaryWrite(message.allocatedCredits, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* bool is_ach_refund_eligible = 30; */
        if (message.isAchRefundEligible !== false)
            writer.tag(30, WireType.Varint).bool(message.isAchRefundEligible);
        /* repeated rd.txn.TaxLine surcharge_taxes = 31; */
        for (let i = 0; i < message.surchargeTaxes.length; i++)
            TaxLine.internalBinaryWrite(message.surchargeTaxes[i], writer.tag(31, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetBillPaymentRes
 */
export const GetBillPaymentRes = new GetBillPaymentRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillPaymentRes_AllocatedFinanceCharge$Type extends MessageType<GetBillPaymentRes_AllocatedFinanceCharge> {
    constructor() {
        super("rd.api.billpayment.GetBillPaymentRes.AllocatedFinanceCharge", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "allocated_amount", kind: "message", T: () => Money },
            { no: 4, name: "location_prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "location_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "assessed_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "created_by", kind: "message", T: () => User },
            { no: 8, name: "customer_id", kind: "message", T: () => UUID },
            { no: 9, name: "customer_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "is_job_finance_charge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetBillPaymentRes_AllocatedFinanceCharge>): GetBillPaymentRes_AllocatedFinanceCharge {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.locationPrefix = "";
        message.locationName = "";
        message.customerIdentifier = "";
        message.customerName = "";
        message.isJobFinanceCharge = false;
        if (value !== undefined)
            reflectionMergePartial<GetBillPaymentRes_AllocatedFinanceCharge>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBillPaymentRes_AllocatedFinanceCharge): GetBillPaymentRes_AllocatedFinanceCharge {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.money.Money allocated_amount */ 3:
                    message.allocatedAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.allocatedAmount);
                    break;
                case /* string location_prefix */ 4:
                    message.locationPrefix = reader.string();
                    break;
                case /* string location_name */ 5:
                    message.locationName = reader.string();
                    break;
                case /* google.protobuf.Timestamp assessed_at */ 6:
                    message.assessedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.assessedAt);
                    break;
                case /* rd.user.User created_by */ 7:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 8:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string customer_identifier */ 9:
                    message.customerIdentifier = reader.string();
                    break;
                case /* string customer_name */ 10:
                    message.customerName = reader.string();
                    break;
                case /* bool is_job_finance_charge */ 11:
                    message.isJobFinanceCharge = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBillPaymentRes_AllocatedFinanceCharge, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.money.Money allocated_amount = 3; */
        if (message.allocatedAmount)
            Money.internalBinaryWrite(message.allocatedAmount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string location_prefix = 4; */
        if (message.locationPrefix !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.locationPrefix);
        /* string location_name = 5; */
        if (message.locationName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.locationName);
        /* google.protobuf.Timestamp assessed_at = 6; */
        if (message.assessedAt)
            Timestamp.internalBinaryWrite(message.assessedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 7; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 8; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string customer_identifier = 9; */
        if (message.customerIdentifier !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.customerIdentifier);
        /* string customer_name = 10; */
        if (message.customerName !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.customerName);
        /* bool is_job_finance_charge = 11; */
        if (message.isJobFinanceCharge !== false)
            writer.tag(11, WireType.Varint).bool(message.isJobFinanceCharge);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetBillPaymentRes.AllocatedFinanceCharge
 */
export const GetBillPaymentRes_AllocatedFinanceCharge = new GetBillPaymentRes_AllocatedFinanceCharge$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetScannedBillPaymentReq$Type extends MessageType<GetScannedBillPaymentReq> {
    constructor() {
        super("rd.api.billpayment.GetScannedBillPaymentReq", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetScannedBillPaymentReq>): GetScannedBillPaymentReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<GetScannedBillPaymentReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetScannedBillPaymentReq): GetScannedBillPaymentReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetScannedBillPaymentReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetScannedBillPaymentReq
 */
export const GetScannedBillPaymentReq = new GetScannedBillPaymentReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetScannedBillPaymentRes$Type extends MessageType<GetScannedBillPaymentRes> {
    constructor() {
        super("rd.api.billpayment.GetScannedBillPaymentRes", [
            { no: 1, name: "bill_payment", kind: "message", T: () => BillPayment }
        ]);
    }
    create(value?: PartialMessage<GetScannedBillPaymentRes>): GetScannedBillPaymentRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetScannedBillPaymentRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetScannedBillPaymentRes): GetScannedBillPaymentRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.BillPayment bill_payment */ 1:
                    message.billPayment = BillPayment.internalBinaryRead(reader, reader.uint32(), options, message.billPayment);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetScannedBillPaymentRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.BillPayment bill_payment = 1; */
        if (message.billPayment)
            BillPayment.internalBinaryWrite(message.billPayment, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetScannedBillPaymentRes
 */
export const GetScannedBillPaymentRes = new GetScannedBillPaymentRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillPaymentPDFReq$Type extends MessageType<GetBillPaymentPDFReq> {
    constructor() {
        super("rd.api.billpayment.GetBillPaymentPDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetBillPaymentPDFReq>): GetBillPaymentPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetBillPaymentPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBillPaymentPDFReq): GetBillPaymentPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBillPaymentPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetBillPaymentPDFReq
 */
export const GetBillPaymentPDFReq = new GetBillPaymentPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillPaymentPDFRes$Type extends MessageType<GetBillPaymentPDFRes> {
    constructor() {
        super("rd.api.billpayment.GetBillPaymentPDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetBillPaymentPDFRes>): GetBillPaymentPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetBillPaymentPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetBillPaymentPDFRes): GetBillPaymentPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetBillPaymentPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetBillPaymentPDFRes
 */
export const GetBillPaymentPDFRes = new GetBillPaymentPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailBillPaymentPDFReq$Type extends MessageType<EmailBillPaymentPDFReq> {
    constructor() {
        super("rd.api.billpayment.EmailBillPaymentPDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "customer_contact_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "additional_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmailBillPaymentPDFReq>): EmailBillPaymentPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customerContactIdStrings = [];
        message.additionalEmails = [];
        if (value !== undefined)
            reflectionMergePartial<EmailBillPaymentPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailBillPaymentPDFReq): EmailBillPaymentPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* repeated string customer_contact_id_strings */ 2:
                    message.customerContactIdStrings.push(reader.string());
                    break;
                case /* repeated string additional_emails */ 3:
                    message.additionalEmails.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailBillPaymentPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string customer_contact_id_strings = 2; */
        for (let i = 0; i < message.customerContactIdStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.customerContactIdStrings[i]);
        /* repeated string additional_emails = 3; */
        for (let i = 0; i < message.additionalEmails.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.additionalEmails[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.EmailBillPaymentPDFReq
 */
export const EmailBillPaymentPDFReq = new EmailBillPaymentPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailBillPaymentPDFRes$Type extends MessageType<EmailBillPaymentPDFRes> {
    constructor() {
        super("rd.api.billpayment.EmailBillPaymentPDFRes", []);
    }
    create(value?: PartialMessage<EmailBillPaymentPDFRes>): EmailBillPaymentPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailBillPaymentPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailBillPaymentPDFRes): EmailBillPaymentPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailBillPaymentPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.EmailBillPaymentPDFRes
 */
export const EmailBillPaymentPDFRes = new EmailBillPaymentPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalculateBillPaymentCardSurchargeReq$Type extends MessageType<CalculateBillPaymentCardSurchargeReq> {
    constructor() {
        super("rd.api.billpayment.CalculateBillPaymentCardSurchargeReq", [
            { no: 1, name: "total", kind: "message", T: () => Money },
            { no: 2, name: "customer_id", kind: "message", T: () => UUID },
            { no: 3, name: "is_card_payment", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "is_card_surcharge_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "location_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<CalculateBillPaymentCardSurchargeReq>): CalculateBillPaymentCardSurchargeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isCardPayment = false;
        message.isCardSurchargeDisabled = false;
        if (value !== undefined)
            reflectionMergePartial<CalculateBillPaymentCardSurchargeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalculateBillPaymentCardSurchargeReq): CalculateBillPaymentCardSurchargeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money total */ 1:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 2:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* bool is_card_payment */ 3:
                    message.isCardPayment = reader.bool();
                    break;
                case /* bool is_card_surcharge_disabled */ 5:
                    message.isCardSurchargeDisabled = reader.bool();
                    break;
                case /* rd.proto.uuid.UUID location_id */ 6:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CalculateBillPaymentCardSurchargeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money total = 1; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 2; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool is_card_payment = 3; */
        if (message.isCardPayment !== false)
            writer.tag(3, WireType.Varint).bool(message.isCardPayment);
        /* bool is_card_surcharge_disabled = 5; */
        if (message.isCardSurchargeDisabled !== false)
            writer.tag(5, WireType.Varint).bool(message.isCardSurchargeDisabled);
        /* rd.proto.uuid.UUID location_id = 6; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.CalculateBillPaymentCardSurchargeReq
 */
export const CalculateBillPaymentCardSurchargeReq = new CalculateBillPaymentCardSurchargeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CalculateBillPaymentCardSurchargeRes$Type extends MessageType<CalculateBillPaymentCardSurchargeRes> {
    constructor() {
        super("rd.api.billpayment.CalculateBillPaymentCardSurchargeRes", [
            { no: 1, name: "surcharge", kind: "message", T: () => Money },
            { no: 3, name: "surcharge_taxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TaxLine }
        ]);
    }
    create(value?: PartialMessage<CalculateBillPaymentCardSurchargeRes>): CalculateBillPaymentCardSurchargeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.surchargeTaxes = [];
        if (value !== undefined)
            reflectionMergePartial<CalculateBillPaymentCardSurchargeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CalculateBillPaymentCardSurchargeRes): CalculateBillPaymentCardSurchargeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money surcharge */ 1:
                    message.surcharge = Money.internalBinaryRead(reader, reader.uint32(), options, message.surcharge);
                    break;
                case /* repeated rd.txn.TaxLine surcharge_taxes */ 3:
                    message.surchargeTaxes.push(TaxLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CalculateBillPaymentCardSurchargeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money surcharge = 1; */
        if (message.surcharge)
            Money.internalBinaryWrite(message.surcharge, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.txn.TaxLine surcharge_taxes = 3; */
        for (let i = 0; i < message.surchargeTaxes.length; i++)
            TaxLine.internalBinaryWrite(message.surchargeTaxes[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.CalculateBillPaymentCardSurchargeRes
 */
export const CalculateBillPaymentCardSurchargeRes = new CalculateBillPaymentCardSurchargeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsVoidingBillPaymentAllowedReq$Type extends MessageType<GetIsVoidingBillPaymentAllowedReq> {
    constructor() {
        super("rd.api.billpayment.GetIsVoidingBillPaymentAllowedReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetIsVoidingBillPaymentAllowedReq>): GetIsVoidingBillPaymentAllowedReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIsVoidingBillPaymentAllowedReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsVoidingBillPaymentAllowedReq): GetIsVoidingBillPaymentAllowedReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsVoidingBillPaymentAllowedReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetIsVoidingBillPaymentAllowedReq
 */
export const GetIsVoidingBillPaymentAllowedReq = new GetIsVoidingBillPaymentAllowedReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsVoidingBillPaymentAllowedRes$Type extends MessageType<GetIsVoidingBillPaymentAllowedRes> {
    constructor() {
        super("rd.api.billpayment.GetIsVoidingBillPaymentAllowedRes", [
            { no: 1, name: "is_allowed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "blocked_reasons", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetIsVoidingBillPaymentAllowedRes>): GetIsVoidingBillPaymentAllowedRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAllowed = false;
        message.blockedReasons = [];
        if (value !== undefined)
            reflectionMergePartial<GetIsVoidingBillPaymentAllowedRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsVoidingBillPaymentAllowedRes): GetIsVoidingBillPaymentAllowedRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_allowed */ 1:
                    message.isAllowed = reader.bool();
                    break;
                case /* repeated string blocked_reasons */ 2:
                    message.blockedReasons.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsVoidingBillPaymentAllowedRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_allowed = 1; */
        if (message.isAllowed !== false)
            writer.tag(1, WireType.Varint).bool(message.isAllowed);
        /* repeated string blocked_reasons = 2; */
        for (let i = 0; i < message.blockedReasons.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.blockedReasons[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetIsVoidingBillPaymentAllowedRes
 */
export const GetIsVoidingBillPaymentAllowedRes = new GetIsVoidingBillPaymentAllowedRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoidBillPaymentReq$Type extends MessageType<VoidBillPaymentReq> {
    constructor() {
        super("rd.api.billpayment.VoidBillPaymentReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "void_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VoidBillPaymentReq>): VoidBillPaymentReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.voidNotes = "";
        if (value !== undefined)
            reflectionMergePartial<VoidBillPaymentReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VoidBillPaymentReq): VoidBillPaymentReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string void_notes */ 2:
                    message.voidNotes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VoidBillPaymentReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string void_notes = 2; */
        if (message.voidNotes !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.voidNotes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.VoidBillPaymentReq
 */
export const VoidBillPaymentReq = new VoidBillPaymentReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoidBillPaymentRes$Type extends MessageType<VoidBillPaymentRes> {
    constructor() {
        super("rd.api.billpayment.VoidBillPaymentRes", []);
    }
    create(value?: PartialMessage<VoidBillPaymentRes>): VoidBillPaymentRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VoidBillPaymentRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VoidBillPaymentRes): VoidBillPaymentRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VoidBillPaymentRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.VoidBillPaymentRes
 */
export const VoidBillPaymentRes = new VoidBillPaymentRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsEditingBillPaymentDateAllowedReq$Type extends MessageType<GetIsEditingBillPaymentDateAllowedReq> {
    constructor() {
        super("rd.api.billpayment.GetIsEditingBillPaymentDateAllowedReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetIsEditingBillPaymentDateAllowedReq>): GetIsEditingBillPaymentDateAllowedReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIsEditingBillPaymentDateAllowedReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsEditingBillPaymentDateAllowedReq): GetIsEditingBillPaymentDateAllowedReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsEditingBillPaymentDateAllowedReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetIsEditingBillPaymentDateAllowedReq
 */
export const GetIsEditingBillPaymentDateAllowedReq = new GetIsEditingBillPaymentDateAllowedReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsEditingBillPaymentDateAllowedRes$Type extends MessageType<GetIsEditingBillPaymentDateAllowedRes> {
    constructor() {
        super("rd.api.billpayment.GetIsEditingBillPaymentDateAllowedRes", [
            { no: 1, name: "is_allowed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "blocked_reasons", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "allowed_date_range", kind: "message", T: () => TimestampRange }
        ]);
    }
    create(value?: PartialMessage<GetIsEditingBillPaymentDateAllowedRes>): GetIsEditingBillPaymentDateAllowedRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAllowed = false;
        message.blockedReasons = [];
        if (value !== undefined)
            reflectionMergePartial<GetIsEditingBillPaymentDateAllowedRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsEditingBillPaymentDateAllowedRes): GetIsEditingBillPaymentDateAllowedRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_allowed */ 1:
                    message.isAllowed = reader.bool();
                    break;
                case /* repeated string blocked_reasons */ 2:
                    message.blockedReasons.push(reader.string());
                    break;
                case /* rd.proto.timestamprange.TimestampRange allowed_date_range */ 3:
                    message.allowedDateRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.allowedDateRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsEditingBillPaymentDateAllowedRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_allowed = 1; */
        if (message.isAllowed !== false)
            writer.tag(1, WireType.Varint).bool(message.isAllowed);
        /* repeated string blocked_reasons = 2; */
        for (let i = 0; i < message.blockedReasons.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.blockedReasons[i]);
        /* rd.proto.timestamprange.TimestampRange allowed_date_range = 3; */
        if (message.allowedDateRange)
            TimestampRange.internalBinaryWrite(message.allowedDateRange, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetIsEditingBillPaymentDateAllowedRes
 */
export const GetIsEditingBillPaymentDateAllowedRes = new GetIsEditingBillPaymentDateAllowedRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBillPaymentDateReq$Type extends MessageType<UpdateBillPaymentDateReq> {
    constructor() {
        super("rd.api.billpayment.UpdateBillPaymentDateReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp, options: { "rd.validator.require": true } },
            { no: 3, name: "client_time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<UpdateBillPaymentDateReq>): UpdateBillPaymentDateReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clientTimeZone = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateBillPaymentDateReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateBillPaymentDateReq): UpdateBillPaymentDateReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 2:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string client_time_zone */ 3:
                    message.clientTimeZone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateBillPaymentDateReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 2; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string client_time_zone = 3; */
        if (message.clientTimeZone !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.clientTimeZone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.UpdateBillPaymentDateReq
 */
export const UpdateBillPaymentDateReq = new UpdateBillPaymentDateReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateBillPaymentDateRes$Type extends MessageType<UpdateBillPaymentDateRes> {
    constructor() {
        super("rd.api.billpayment.UpdateBillPaymentDateRes", []);
    }
    create(value?: PartialMessage<UpdateBillPaymentDateRes>): UpdateBillPaymentDateRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateBillPaymentDateRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateBillPaymentDateRes): UpdateBillPaymentDateRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateBillPaymentDateRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.UpdateBillPaymentDateRes
 */
export const UpdateBillPaymentDateRes = new UpdateBillPaymentDateRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsReallocatingBillPaymentAllowedReq$Type extends MessageType<GetIsReallocatingBillPaymentAllowedReq> {
    constructor() {
        super("rd.api.billpayment.GetIsReallocatingBillPaymentAllowedReq", [
            { no: 1, name: "bill_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetIsReallocatingBillPaymentAllowedReq>): GetIsReallocatingBillPaymentAllowedReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIsReallocatingBillPaymentAllowedReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsReallocatingBillPaymentAllowedReq): GetIsReallocatingBillPaymentAllowedReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID bill_id */ 1:
                    message.billId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.billId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsReallocatingBillPaymentAllowedReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID bill_id = 1; */
        if (message.billId)
            UUID.internalBinaryWrite(message.billId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetIsReallocatingBillPaymentAllowedReq
 */
export const GetIsReallocatingBillPaymentAllowedReq = new GetIsReallocatingBillPaymentAllowedReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsReallocatingBillPaymentAllowedRes$Type extends MessageType<GetIsReallocatingBillPaymentAllowedRes> {
    constructor() {
        super("rd.api.billpayment.GetIsReallocatingBillPaymentAllowedRes", [
            { no: 1, name: "is_allowed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "blocked_reasons", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetIsReallocatingBillPaymentAllowedRes>): GetIsReallocatingBillPaymentAllowedRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAllowed = false;
        message.blockedReasons = [];
        if (value !== undefined)
            reflectionMergePartial<GetIsReallocatingBillPaymentAllowedRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsReallocatingBillPaymentAllowedRes): GetIsReallocatingBillPaymentAllowedRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_allowed */ 1:
                    message.isAllowed = reader.bool();
                    break;
                case /* repeated string blocked_reasons */ 2:
                    message.blockedReasons.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsReallocatingBillPaymentAllowedRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_allowed = 1; */
        if (message.isAllowed !== false)
            writer.tag(1, WireType.Varint).bool(message.isAllowed);
        /* repeated string blocked_reasons = 2; */
        for (let i = 0; i < message.blockedReasons.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.blockedReasons[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetIsReallocatingBillPaymentAllowedRes
 */
export const GetIsReallocatingBillPaymentAllowedRes = new GetIsReallocatingBillPaymentAllowedRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReallocateBillPaymentReq$Type extends MessageType<ReallocateBillPaymentReq> {
    constructor() {
        super("rd.api.billpayment.ReallocateBillPaymentReq", [
            { no: 1, name: "bill_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "reallocations_by_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ReallocateBillPaymentReq_Allocation } },
            { no: 3, name: "unallocated_credits_added", kind: "message", T: () => Money },
            { no: 4, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "credit_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ReallocateBillPaymentReq>): ReallocateBillPaymentReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reallocationsById = {};
        message.notes = "";
        message.creditNotes = "";
        if (value !== undefined)
            reflectionMergePartial<ReallocateBillPaymentReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReallocateBillPaymentReq): ReallocateBillPaymentReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID bill_id */ 1:
                    message.billId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.billId);
                    break;
                case /* map<string, rd.api.billpayment.ReallocateBillPaymentReq.Allocation> reallocations_by_id */ 2:
                    this.binaryReadMap2(message.reallocationsById, reader, options);
                    break;
                case /* rd.proto.money.Money unallocated_credits_added */ 3:
                    message.unallocatedCreditsAdded = Money.internalBinaryRead(reader, reader.uint32(), options, message.unallocatedCreditsAdded);
                    break;
                case /* string notes */ 4:
                    message.notes = reader.string();
                    break;
                case /* string credit_notes */ 5:
                    message.creditNotes = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: ReallocateBillPaymentReq["reallocationsById"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ReallocateBillPaymentReq["reallocationsById"] | undefined, val: ReallocateBillPaymentReq["reallocationsById"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = ReallocateBillPaymentReq_Allocation.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.api.billpayment.ReallocateBillPaymentReq.reallocations_by_id");
            }
        }
        map[key ?? ""] = val ?? ReallocateBillPaymentReq_Allocation.create();
    }
    internalBinaryWrite(message: ReallocateBillPaymentReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID bill_id = 1; */
        if (message.billId)
            UUID.internalBinaryWrite(message.billId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* map<string, rd.api.billpayment.ReallocateBillPaymentReq.Allocation> reallocations_by_id = 2; */
        for (let k of globalThis.Object.keys(message.reallocationsById)) {
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            ReallocateBillPaymentReq_Allocation.internalBinaryWrite(message.reallocationsById[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.money.Money unallocated_credits_added = 3; */
        if (message.unallocatedCreditsAdded)
            Money.internalBinaryWrite(message.unallocatedCreditsAdded, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 4; */
        if (message.notes !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.notes);
        /* string credit_notes = 5; */
        if (message.creditNotes !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.creditNotes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.ReallocateBillPaymentReq
 */
export const ReallocateBillPaymentReq = new ReallocateBillPaymentReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReallocateBillPaymentReq_Allocation$Type extends MessageType<ReallocateBillPaymentReq_Allocation> {
    constructor() {
        super("rd.api.billpayment.ReallocateBillPaymentReq.Allocation", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "amount", kind: "message", T: () => Money },
            { no: 3, name: "type", kind: "enum", T: () => ["rd.api.billpayment.ReallocateBillPaymentReq.Type", ReallocateBillPaymentReq_Type, "TYPE_"] }
        ]);
    }
    create(value?: PartialMessage<ReallocateBillPaymentReq_Allocation>): ReallocateBillPaymentReq_Allocation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<ReallocateBillPaymentReq_Allocation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReallocateBillPaymentReq_Allocation): ReallocateBillPaymentReq_Allocation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.money.Money amount */ 2:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* rd.api.billpayment.ReallocateBillPaymentReq.Type type */ 3:
                    message.type = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReallocateBillPaymentReq_Allocation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money amount = 2; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.billpayment.ReallocateBillPaymentReq.Type type = 3; */
        if (message.type !== 0)
            writer.tag(3, WireType.Varint).int32(message.type);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.ReallocateBillPaymentReq.Allocation
 */
export const ReallocateBillPaymentReq_Allocation = new ReallocateBillPaymentReq_Allocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReallocateBillPaymentRes$Type extends MessageType<ReallocateBillPaymentRes> {
    constructor() {
        super("rd.api.billpayment.ReallocateBillPaymentRes", []);
    }
    create(value?: PartialMessage<ReallocateBillPaymentRes>): ReallocateBillPaymentRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ReallocateBillPaymentRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReallocateBillPaymentRes): ReallocateBillPaymentRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReallocateBillPaymentRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.ReallocateBillPaymentRes
 */
export const ReallocateBillPaymentRes = new ReallocateBillPaymentRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargeReq$Type extends MessageType<GetFinanceChargeReq> {
    constructor() {
        super("rd.api.billpayment.GetFinanceChargeReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetFinanceChargeReq>): GetFinanceChargeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargeReq): GetFinanceChargeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetFinanceChargeReq
 */
export const GetFinanceChargeReq = new GetFinanceChargeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargeRes$Type extends MessageType<GetFinanceChargeRes> {
    constructor() {
        super("rd.api.billpayment.GetFinanceChargeRes", [
            { no: 1, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "customer_id", kind: "message", T: () => UUID },
            { no: 4, name: "assessed_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "adjustment", kind: "message", T: () => Money },
            { no: 6, name: "rate", kind: "message", T: () => Decimal },
            { no: 7, name: "total", kind: "message", T: () => Money },
            { no: 8, name: "net_allocated_amount", kind: "message", T: () => Money },
            { no: 9, name: "total_balance", kind: "message", T: () => Money },
            { no: 10, name: "assessed_transactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetFinanceChargeRes_AssessedTransaction }
        ]);
    }
    create(value?: PartialMessage<GetFinanceChargeRes>): GetFinanceChargeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.locationPrefix = "";
        message.assessedTransactions = [];
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargeRes): GetFinanceChargeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string identifier */ 1:
                    message.identifier = reader.string();
                    break;
                case /* string location_prefix */ 2:
                    message.locationPrefix = reader.string();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 3:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* google.protobuf.Timestamp assessed_at */ 4:
                    message.assessedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.assessedAt);
                    break;
                case /* rd.proto.money.Money adjustment */ 5:
                    message.adjustment = Money.internalBinaryRead(reader, reader.uint32(), options, message.adjustment);
                    break;
                case /* rd.proto.decimal.Decimal rate */ 6:
                    message.rate = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.rate);
                    break;
                case /* rd.proto.money.Money total */ 7:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.proto.money.Money net_allocated_amount */ 8:
                    message.netAllocatedAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.netAllocatedAmount);
                    break;
                case /* rd.proto.money.Money total_balance */ 9:
                    message.totalBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.totalBalance);
                    break;
                case /* repeated rd.api.billpayment.GetFinanceChargeRes.AssessedTransaction assessed_transactions */ 10:
                    message.assessedTransactions.push(GetFinanceChargeRes_AssessedTransaction.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string identifier = 1; */
        if (message.identifier !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.identifier);
        /* string location_prefix = 2; */
        if (message.locationPrefix !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.locationPrefix);
        /* rd.proto.uuid.UUID customer_id = 3; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp assessed_at = 4; */
        if (message.assessedAt)
            Timestamp.internalBinaryWrite(message.assessedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money adjustment = 5; */
        if (message.adjustment)
            Money.internalBinaryWrite(message.adjustment, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal rate = 6; */
        if (message.rate)
            Decimal.internalBinaryWrite(message.rate, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 7; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money net_allocated_amount = 8; */
        if (message.netAllocatedAmount)
            Money.internalBinaryWrite(message.netAllocatedAmount, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total_balance = 9; */
        if (message.totalBalance)
            Money.internalBinaryWrite(message.totalBalance, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.billpayment.GetFinanceChargeRes.AssessedTransaction assessed_transactions = 10; */
        for (let i = 0; i < message.assessedTransactions.length; i++)
            GetFinanceChargeRes_AssessedTransaction.internalBinaryWrite(message.assessedTransactions[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetFinanceChargeRes
 */
export const GetFinanceChargeRes = new GetFinanceChargeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargeRes_AssessedTransaction$Type extends MessageType<GetFinanceChargeRes_AssessedTransaction> {
    constructor() {
        super("rd.api.billpayment.GetFinanceChargeRes.AssessedTransaction", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "due_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "transaction_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "job_id", kind: "message", T: () => UUID },
            { no: 7, name: "job_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<GetFinanceChargeRes_AssessedTransaction>): GetFinanceChargeRes_AssessedTransaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.transactionType = "";
        message.jobIdentifier = "";
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargeRes_AssessedTransaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargeRes_AssessedTransaction): GetFinanceChargeRes_AssessedTransaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp due_at */ 4:
                    message.dueAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueAt);
                    break;
                case /* string transaction_type */ 5:
                    message.transactionType = reader.string();
                    break;
                case /* rd.proto.uuid.UUID job_id */ 6:
                    message.jobId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.jobId);
                    break;
                case /* string job_identifier */ 7:
                    message.jobIdentifier = reader.string();
                    break;
                case /* rd.proto.money.Money balance */ 8:
                    message.balance = Money.internalBinaryRead(reader, reader.uint32(), options, message.balance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargeRes_AssessedTransaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp due_at = 4; */
        if (message.dueAt)
            Timestamp.internalBinaryWrite(message.dueAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string transaction_type = 5; */
        if (message.transactionType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.transactionType);
        /* rd.proto.uuid.UUID job_id = 6; */
        if (message.jobId)
            UUID.internalBinaryWrite(message.jobId, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string job_identifier = 7; */
        if (message.jobIdentifier !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.jobIdentifier);
        /* rd.proto.money.Money balance = 8; */
        if (message.balance)
            Money.internalBinaryWrite(message.balance, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetFinanceChargeRes.AssessedTransaction
 */
export const GetFinanceChargeRes_AssessedTransaction = new GetFinanceChargeRes_AssessedTransaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargePDFReq$Type extends MessageType<GetFinanceChargePDFReq> {
    constructor() {
        super("rd.api.billpayment.GetFinanceChargePDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetFinanceChargePDFReq>): GetFinanceChargePDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargePDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargePDFReq): GetFinanceChargePDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargePDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetFinanceChargePDFReq
 */
export const GetFinanceChargePDFReq = new GetFinanceChargePDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFinanceChargePDFRes$Type extends MessageType<GetFinanceChargePDFRes> {
    constructor() {
        super("rd.api.billpayment.GetFinanceChargePDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetFinanceChargePDFRes>): GetFinanceChargePDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetFinanceChargePDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetFinanceChargePDFRes): GetFinanceChargePDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetFinanceChargePDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetFinanceChargePDFRes
 */
export const GetFinanceChargePDFRes = new GetFinanceChargePDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailFinanceChargePDFReq$Type extends MessageType<EmailFinanceChargePDFReq> {
    constructor() {
        super("rd.api.billpayment.EmailFinanceChargePDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "customer_contact_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "additional_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmailFinanceChargePDFReq>): EmailFinanceChargePDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customerContactIdStrings = [];
        message.additionalEmails = [];
        if (value !== undefined)
            reflectionMergePartial<EmailFinanceChargePDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailFinanceChargePDFReq): EmailFinanceChargePDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* repeated string customer_contact_id_strings */ 2:
                    message.customerContactIdStrings.push(reader.string());
                    break;
                case /* repeated string additional_emails */ 3:
                    message.additionalEmails.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailFinanceChargePDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string customer_contact_id_strings = 2; */
        for (let i = 0; i < message.customerContactIdStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.customerContactIdStrings[i]);
        /* repeated string additional_emails = 3; */
        for (let i = 0; i < message.additionalEmails.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.additionalEmails[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.EmailFinanceChargePDFReq
 */
export const EmailFinanceChargePDFReq = new EmailFinanceChargePDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailFinanceChargePDFRes$Type extends MessageType<EmailFinanceChargePDFRes> {
    constructor() {
        super("rd.api.billpayment.EmailFinanceChargePDFRes", []);
    }
    create(value?: PartialMessage<EmailFinanceChargePDFRes>): EmailFinanceChargePDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailFinanceChargePDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailFinanceChargePDFRes): EmailFinanceChargePDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailFinanceChargePDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.EmailFinanceChargePDFRes
 */
export const EmailFinanceChargePDFRes = new EmailFinanceChargePDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsVoidingFinanceChargeAllowedReq$Type extends MessageType<GetIsVoidingFinanceChargeAllowedReq> {
    constructor() {
        super("rd.api.billpayment.GetIsVoidingFinanceChargeAllowedReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetIsVoidingFinanceChargeAllowedReq>): GetIsVoidingFinanceChargeAllowedReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetIsVoidingFinanceChargeAllowedReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsVoidingFinanceChargeAllowedReq): GetIsVoidingFinanceChargeAllowedReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsVoidingFinanceChargeAllowedReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetIsVoidingFinanceChargeAllowedReq
 */
export const GetIsVoidingFinanceChargeAllowedReq = new GetIsVoidingFinanceChargeAllowedReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIsVoidingFinanceChargeAllowedRes$Type extends MessageType<GetIsVoidingFinanceChargeAllowedRes> {
    constructor() {
        super("rd.api.billpayment.GetIsVoidingFinanceChargeAllowedRes", [
            { no: 1, name: "is_allowed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "blocked_reasons", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetIsVoidingFinanceChargeAllowedRes>): GetIsVoidingFinanceChargeAllowedRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAllowed = false;
        message.blockedReasons = [];
        if (value !== undefined)
            reflectionMergePartial<GetIsVoidingFinanceChargeAllowedRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetIsVoidingFinanceChargeAllowedRes): GetIsVoidingFinanceChargeAllowedRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_allowed */ 1:
                    message.isAllowed = reader.bool();
                    break;
                case /* repeated string blocked_reasons */ 2:
                    message.blockedReasons.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetIsVoidingFinanceChargeAllowedRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_allowed = 1; */
        if (message.isAllowed !== false)
            writer.tag(1, WireType.Varint).bool(message.isAllowed);
        /* repeated string blocked_reasons = 2; */
        for (let i = 0; i < message.blockedReasons.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.blockedReasons[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetIsVoidingFinanceChargeAllowedRes
 */
export const GetIsVoidingFinanceChargeAllowedRes = new GetIsVoidingFinanceChargeAllowedRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoidFinanceChargeReq$Type extends MessageType<VoidFinanceChargeReq> {
    constructor() {
        super("rd.api.billpayment.VoidFinanceChargeReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<VoidFinanceChargeReq>): VoidFinanceChargeReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VoidFinanceChargeReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VoidFinanceChargeReq): VoidFinanceChargeReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VoidFinanceChargeReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.VoidFinanceChargeReq
 */
export const VoidFinanceChargeReq = new VoidFinanceChargeReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VoidFinanceChargeRes$Type extends MessageType<VoidFinanceChargeRes> {
    constructor() {
        super("rd.api.billpayment.VoidFinanceChargeRes", []);
    }
    create(value?: PartialMessage<VoidFinanceChargeRes>): VoidFinanceChargeRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VoidFinanceChargeRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VoidFinanceChargeRes): VoidFinanceChargeRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VoidFinanceChargeRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.VoidFinanceChargeRes
 */
export const VoidFinanceChargeRes = new VoidFinanceChargeRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCreditHistoryReq$Type extends MessageType<GetCreditHistoryReq> {
    constructor() {
        super("rd.api.billpayment.GetCreditHistoryReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetCreditHistoryReq>): GetCreditHistoryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCreditHistoryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCreditHistoryReq): GetCreditHistoryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCreditHistoryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetCreditHistoryReq
 */
export const GetCreditHistoryReq = new GetCreditHistoryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCreditHistoryRes$Type extends MessageType<GetCreditHistoryRes> {
    constructor() {
        super("rd.api.billpayment.GetCreditHistoryRes", [
            { no: 1, name: "txn_id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "location_prefix", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "customer_id", kind: "message", T: () => UUID },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "allocated_total", kind: "message", T: () => Money },
            { no: 7, name: "total", kind: "message", T: () => Money },
            { no: 8, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "txn_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "created_by", kind: "message", T: () => User },
            { no: 12, name: "type", kind: "enum", T: () => ["rd.api.billpayment.GetCreditHistoryRes.Type", GetCreditHistoryRes_Type, "TYPE_"] },
            { no: 13, name: "receivable", kind: "message", T: () => Receivable },
            { no: 14, name: "receivable_history", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetCreditHistoryRes_ReceivableHistoryItem }
        ]);
    }
    create(value?: PartialMessage<GetCreditHistoryRes>): GetCreditHistoryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.locationPrefix = "";
        message.notes = "";
        message.txnIdentifier = "";
        message.type = 0;
        message.receivableHistory = [];
        if (value !== undefined)
            reflectionMergePartial<GetCreditHistoryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCreditHistoryRes): GetCreditHistoryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID txn_id */ 1:
                    message.txnId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.txnId);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* string location_prefix */ 3:
                    message.locationPrefix = reader.string();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 4:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.proto.money.Money allocated_total */ 6:
                    message.allocatedTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.allocatedTotal);
                    break;
                case /* rd.proto.money.Money total */ 7:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* string notes */ 8:
                    message.notes = reader.string();
                    break;
                case /* string txn_identifier */ 10:
                    message.txnIdentifier = reader.string();
                    break;
                case /* rd.user.User created_by */ 11:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.api.billpayment.GetCreditHistoryRes.Type type */ 12:
                    message.type = reader.int32();
                    break;
                case /* rd.txn.Receivable receivable */ 13:
                    message.receivable = Receivable.internalBinaryRead(reader, reader.uint32(), options, message.receivable);
                    break;
                case /* repeated rd.api.billpayment.GetCreditHistoryRes.ReceivableHistoryItem receivable_history */ 14:
                    message.receivableHistory.push(GetCreditHistoryRes_ReceivableHistoryItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCreditHistoryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID txn_id = 1; */
        if (message.txnId)
            UUID.internalBinaryWrite(message.txnId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* string location_prefix = 3; */
        if (message.locationPrefix !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.locationPrefix);
        /* rd.proto.uuid.UUID customer_id = 4; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money allocated_total = 6; */
        if (message.allocatedTotal)
            Money.internalBinaryWrite(message.allocatedTotal, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money total = 7; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string notes = 8; */
        if (message.notes !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.notes);
        /* string txn_identifier = 10; */
        if (message.txnIdentifier !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.txnIdentifier);
        /* rd.user.User created_by = 11; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.api.billpayment.GetCreditHistoryRes.Type type = 12; */
        if (message.type !== 0)
            writer.tag(12, WireType.Varint).int32(message.type);
        /* rd.txn.Receivable receivable = 13; */
        if (message.receivable)
            Receivable.internalBinaryWrite(message.receivable, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.api.billpayment.GetCreditHistoryRes.ReceivableHistoryItem receivable_history = 14; */
        for (let i = 0; i < message.receivableHistory.length; i++)
            GetCreditHistoryRes_ReceivableHistoryItem.internalBinaryWrite(message.receivableHistory[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetCreditHistoryRes
 */
export const GetCreditHistoryRes = new GetCreditHistoryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCreditHistoryRes_Allocation$Type extends MessageType<GetCreditHistoryRes_Allocation> {
    constructor() {
        super("rd.api.billpayment.GetCreditHistoryRes.Allocation", []);
    }
    create(value?: PartialMessage<GetCreditHistoryRes_Allocation>): GetCreditHistoryRes_Allocation {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCreditHistoryRes_Allocation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCreditHistoryRes_Allocation): GetCreditHistoryRes_Allocation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCreditHistoryRes_Allocation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetCreditHistoryRes.Allocation
 */
export const GetCreditHistoryRes_Allocation = new GetCreditHistoryRes_Allocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCreditHistoryRes_ReceivableHistoryItem$Type extends MessageType<GetCreditHistoryRes_ReceivableHistoryItem> {
    constructor() {
        super("rd.api.billpayment.GetCreditHistoryRes.ReceivableHistoryItem", [
            { no: 1, name: "receivable", kind: "message", T: () => Receivable },
            { no: 2, name: "balance_delta", kind: "message", T: () => Money },
            { no: 3, name: "running_balance", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<GetCreditHistoryRes_ReceivableHistoryItem>): GetCreditHistoryRes_ReceivableHistoryItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCreditHistoryRes_ReceivableHistoryItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCreditHistoryRes_ReceivableHistoryItem): GetCreditHistoryRes_ReceivableHistoryItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.txn.Receivable receivable */ 1:
                    message.receivable = Receivable.internalBinaryRead(reader, reader.uint32(), options, message.receivable);
                    break;
                case /* rd.proto.money.Money balance_delta */ 2:
                    message.balanceDelta = Money.internalBinaryRead(reader, reader.uint32(), options, message.balanceDelta);
                    break;
                case /* rd.proto.money.Money running_balance */ 3:
                    message.runningBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.runningBalance);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCreditHistoryRes_ReceivableHistoryItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.txn.Receivable receivable = 1; */
        if (message.receivable)
            Receivable.internalBinaryWrite(message.receivable, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money balance_delta = 2; */
        if (message.balanceDelta)
            Money.internalBinaryWrite(message.balanceDelta, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money running_balance = 3; */
        if (message.runningBalance)
            Money.internalBinaryWrite(message.runningBalance, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetCreditHistoryRes.ReceivableHistoryItem
 */
export const GetCreditHistoryRes_ReceivableHistoryItem = new GetCreditHistoryRes_ReceivableHistoryItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCreditHistoryPDFReq$Type extends MessageType<GetCreditHistoryPDFReq> {
    constructor() {
        super("rd.api.billpayment.GetCreditHistoryPDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetCreditHistoryPDFReq>): GetCreditHistoryPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetCreditHistoryPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCreditHistoryPDFReq): GetCreditHistoryPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCreditHistoryPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetCreditHistoryPDFReq
 */
export const GetCreditHistoryPDFReq = new GetCreditHistoryPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetCreditHistoryPDFRes$Type extends MessageType<GetCreditHistoryPDFRes> {
    constructor() {
        super("rd.api.billpayment.GetCreditHistoryPDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetCreditHistoryPDFRes>): GetCreditHistoryPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetCreditHistoryPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetCreditHistoryPDFRes): GetCreditHistoryPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetCreditHistoryPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetCreditHistoryPDFRes
 */
export const GetCreditHistoryPDFRes = new GetCreditHistoryPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailCreditHistoryPDFReq$Type extends MessageType<EmailCreditHistoryPDFReq> {
    constructor() {
        super("rd.api.billpayment.EmailCreditHistoryPDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "customer_contact_id_strings", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "additional_emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EmailCreditHistoryPDFReq>): EmailCreditHistoryPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.customerContactIdStrings = [];
        message.additionalEmails = [];
        if (value !== undefined)
            reflectionMergePartial<EmailCreditHistoryPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailCreditHistoryPDFReq): EmailCreditHistoryPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* repeated string customer_contact_id_strings */ 2:
                    message.customerContactIdStrings.push(reader.string());
                    break;
                case /* repeated string additional_emails */ 3:
                    message.additionalEmails.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailCreditHistoryPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated string customer_contact_id_strings = 2; */
        for (let i = 0; i < message.customerContactIdStrings.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.customerContactIdStrings[i]);
        /* repeated string additional_emails = 3; */
        for (let i = 0; i < message.additionalEmails.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.additionalEmails[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.EmailCreditHistoryPDFReq
 */
export const EmailCreditHistoryPDFReq = new EmailCreditHistoryPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailCreditHistoryPDFRes$Type extends MessageType<EmailCreditHistoryPDFRes> {
    constructor() {
        super("rd.api.billpayment.EmailCreditHistoryPDFRes", []);
    }
    create(value?: PartialMessage<EmailCreditHistoryPDFRes>): EmailCreditHistoryPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EmailCreditHistoryPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailCreditHistoryPDFRes): EmailCreditHistoryPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailCreditHistoryPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.EmailCreditHistoryPDFRes
 */
export const EmailCreditHistoryPDFRes = new EmailCreditHistoryPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNonFullyAllocatedCreditHistoryCountReq$Type extends MessageType<GetNonFullyAllocatedCreditHistoryCountReq> {
    constructor() {
        super("rd.api.billpayment.GetNonFullyAllocatedCreditHistoryCountReq", [
            { no: 1, name: "customer_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<GetNonFullyAllocatedCreditHistoryCountReq>): GetNonFullyAllocatedCreditHistoryCountReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetNonFullyAllocatedCreditHistoryCountReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNonFullyAllocatedCreditHistoryCountReq): GetNonFullyAllocatedCreditHistoryCountReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID customer_id */ 1:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNonFullyAllocatedCreditHistoryCountReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID customer_id = 1; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetNonFullyAllocatedCreditHistoryCountReq
 */
export const GetNonFullyAllocatedCreditHistoryCountReq = new GetNonFullyAllocatedCreditHistoryCountReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetNonFullyAllocatedCreditHistoryCountRes$Type extends MessageType<GetNonFullyAllocatedCreditHistoryCountRes> {
    constructor() {
        super("rd.api.billpayment.GetNonFullyAllocatedCreditHistoryCountRes", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<GetNonFullyAllocatedCreditHistoryCountRes>): GetNonFullyAllocatedCreditHistoryCountRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetNonFullyAllocatedCreditHistoryCountRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetNonFullyAllocatedCreditHistoryCountRes): GetNonFullyAllocatedCreditHistoryCountRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetNonFullyAllocatedCreditHistoryCountRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.billpayment.GetNonFullyAllocatedCreditHistoryCountRes
 */
export const GetNonFullyAllocatedCreditHistoryCountRes = new GetNonFullyAllocatedCreditHistoryCountRes$Type();
/**
 * @generated ServiceType for protobuf service rd.api.billpayment.BillPaymentService
 */
export const BillPaymentService = new ServiceType("rd.api.billpayment.BillPaymentService", [
    { name: "CreateBillPaymentV3", options: {}, I: CreateBillPaymentV3Req, O: CreateBillPaymentV3Res },
    { name: "RefundBillPayment", options: {}, I: RefundBillPaymentReq, O: RefundBillPaymentRes },
    { name: "CreateWriteOff", options: {}, I: CreateWriteOffReq, O: CreateWriteOffRes },
    { name: "GetBillPayment", options: {}, I: GetBillPaymentReq, O: GetBillPaymentRes },
    { name: "GetScannedBillPayment", options: {}, I: GetScannedBillPaymentReq, O: GetScannedBillPaymentRes },
    { name: "GetBillPaymentPDF", options: {}, I: GetBillPaymentPDFReq, O: GetBillPaymentPDFRes },
    { name: "EmailBillPaymentPDF", options: {}, I: EmailBillPaymentPDFReq, O: EmailBillPaymentPDFRes },
    { name: "CalculateBillPaymentCardSurcharge", options: {}, I: CalculateBillPaymentCardSurchargeReq, O: CalculateBillPaymentCardSurchargeRes },
    { name: "GetIsVoidingBillPaymentAllowed", options: {}, I: GetIsVoidingBillPaymentAllowedReq, O: GetIsVoidingBillPaymentAllowedRes },
    { name: "VoidBillPayment", options: {}, I: VoidBillPaymentReq, O: VoidBillPaymentRes },
    { name: "GetIsEditingBillPaymentDateAllowed", options: {}, I: GetIsEditingBillPaymentDateAllowedReq, O: GetIsEditingBillPaymentDateAllowedRes },
    { name: "UpdateBillPaymentDate", options: {}, I: UpdateBillPaymentDateReq, O: UpdateBillPaymentDateRes },
    { name: "GetIsReallocatingBillPaymentAllowed", options: {}, I: GetIsReallocatingBillPaymentAllowedReq, O: GetIsReallocatingBillPaymentAllowedRes },
    { name: "ReallocateBillPayment", options: {}, I: ReallocateBillPaymentReq, O: ReallocateBillPaymentRes },
    { name: "GetFinanceCharge", options: {}, I: GetFinanceChargeReq, O: GetFinanceChargeRes },
    { name: "GetFinanceChargePDF", options: {}, I: GetFinanceChargePDFReq, O: GetFinanceChargePDFRes },
    { name: "EmailFinanceChargePDF", options: {}, I: EmailFinanceChargePDFReq, O: EmailFinanceChargePDFRes },
    { name: "GetIsVoidingFinanceChargeAllowed", options: {}, I: GetIsVoidingFinanceChargeAllowedReq, O: GetIsVoidingFinanceChargeAllowedRes },
    { name: "VoidFinanceCharge", options: {}, I: VoidFinanceChargeReq, O: VoidFinanceChargeRes },
    { name: "GetCreditHistory", options: {}, I: GetCreditHistoryReq, O: GetCreditHistoryRes },
    { name: "GetCreditHistoryPDF", options: {}, I: GetCreditHistoryPDFReq, O: GetCreditHistoryPDFRes },
    { name: "EmailCreditHistoryPDF", options: {}, I: EmailCreditHistoryPDFReq, O: EmailCreditHistoryPDFRes },
    { name: "GetNonFullyAllocatedCreditHistoryCount", options: {}, I: GetNonFullyAllocatedCreditHistoryCountReq, O: GetNonFullyAllocatedCreditHistoryCountRes }
]);
